<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <EXCMDeviceStateForm
            v-if="item"
            :handle-submit="onSendForm"
            :handle-update-field="updateField"
            :values="item"
            :errors="violations"
            :initial-values="retrieved" />
        </div>
      </div>
      <button
        type="button"
        @click="goBack()"
        class="btn btn-default">{{$t('buttons.goBack')}}</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMDeviceStateForm from './Form.vue'
// import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  components: {
    EXCMDeviceStateForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmdevicestate/update/isLoading',
      error: 'excmdevicestate/update/error',
      deleteError: 'excmdevicestate/del/error',
      deleteLoading: 'excmdevicestate/del/isLoading',
      created: 'excmdevicestate/create/created',
      deleted: 'excmdevicestate/del/deleted',
      retrieved: 'excmdevicestate/update/retrieved',
      updated: 'excmdevicestate/update/updated',
      violations: 'excmdevicestate/update/violations'
    })
  },

  beforeCreate () {
    // checkPagePermission('notes', 'excmdevicestateUpdate')
    return true
  },

  watch: {
    updated (val) {
      if (val) {
        this.$router.go(-1)
      }
    },
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.go(-1)
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    goBack () {
      this.$router.go(-1)
    },
    ...mapActions({
      createReset: 'excmdevicestate/create/reset',
      deleteItem: 'excmdevicestate/del/del',
      delReset: 'excmdevicestate/del/reset',
      retrieve: 'excmdevicestate/update/retrieve',
      updateReset: 'excmdevicestate/update/reset',
      update: 'excmdevicestate/update/update',
      updateRetrieved: 'excmdevicestate/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmdevicestate ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
